import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, OnChanges, SimpleChanges, inject } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, transition, style, animate, state } from '@angular/animations';

@Component({
  selector: 'app-confirmation-panel',
  templateUrl: './confirmation-panel.component.html',
  styleUrls: ['./confirmation-panel.component.scss'],
  standalone: false,
  animations: [
    trigger('backdrop', [
      transition(':enter', [style({ opacity: 0 }), animate('200ms ease-out', style({ opacity: 1 }))]),
      transition(':leave', [animate('200ms ease-in', style({ opacity: 0 }))]),
    ]),
    trigger('panel', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.9) translateY(-20px)' }),
        animate('300ms cubic-bezier(0.34, 1.56, 0.64, 1)', style({ opacity: 1, transform: 'scale(1) translateY(0)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'scale(0.95) translateY(-10px)' })),
      ]),
    ]),
    trigger('icon', [
      state('visible', style({ transform: 'scale(1)' })),
      transition(':enter', [
        style({ transform: 'scale(0)' }),
        animate('400ms cubic-bezier(0.34, 1.56, 0.64, 1)', style({ transform: 'scale(1)' })),
      ]),
    ]),
    trigger('checkmark', [
      transition(':enter', [
        style({ strokeDashoffset: 100 }),
        animate('600ms 200ms ease-out', style({ strokeDashoffset: 0 })),
      ]),
    ]),
    trigger('text', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate('400ms 300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
    ]),
  ],
})
export class ConfirmationPanelComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isVisible = false;
  @Input() title = '¡Operación exitosa!';
  @Input() message = 'La acción se completó correctamente.';
  @Input() duration = 3000; // ms
  // Nuevos controles
  @Input() disableManualClose = true; // evita cerrar por click o 'X'
  @Input() navigateTo?: string | any[]; // ruta destino al finalizar
  @Output() close = new EventEmitter<void>();

  progress = 100;
  private intervalId?: number;
  private readonly router = inject(Router);

  ngOnInit() {
    if (this.isVisible) {
      this.startProgress();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isVisible']) {
      if (this.isVisible) {
        this.progress = 100;
        this.startProgress();
      } else {
        this.clearProgress();
      }
    }
  }

  ngOnDestroy() {
    this.clearProgress();
  }

  handleClose() {
    // Si no se permite cierre manual, ignorar click
    if (this.disableManualClose && this.progress > 0) {
      return;
    }
    this.close.emit();
    // Navegación opcional al cerrar
    if (this.navigateTo) {
      this.router.navigate(Array.isArray(this.navigateTo) ? this.navigateTo : [this.navigateTo]).catch(() => {});
    }
  }

  private startProgress() {
    this.clearProgress();
    const interval = 50;
    const decrement = (interval / this.duration) * 100;

    this.intervalId = window.setInterval(() => {
      this.progress -= decrement;
      if (this.progress <= 0) {
        this.progress = 0;
        this.clearProgress();
        // Cierre programático (permitido)
        this.close.emit();
        if (this.navigateTo) {
          this.router.navigate(Array.isArray(this.navigateTo) ? this.navigateTo : [this.navigateTo]).catch(() => {});
        }
      }
    }, interval);
  }

  private clearProgress() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
  }
}
